import Fuse from 'fuse.js'
import type { WF_OpenWorkflow } from './WF.OpenWorkflow'

export const WF_filterOpenWorkflow = (openWorkflow: WF_OpenWorkflow, searchTerm: string) => {
    if (!searchTerm) return openWorkflow
    if (!openWorkflow) return null

    const isMatch: boolean =
        new Fuse([openWorkflow], {
            keys: ['procedureName', 'workflowName'],
            threshold: 0.3,
        }).search(searchTerm).length !== 0

    return isMatch ? openWorkflow : null
}
